
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/access",
      function () {
        return require("private-next-pages/access.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/access"])
      });
    }
  